export enum MainCriterias {
  INVOICE_REF = "Invoice Ref",
  INVOICE = "Invoice",
  CASE = "Case",
  DEBTOR = "Debtor",
  CREDITOR = "Creditor",
}
